import { render, staticRenderFns } from "./LanguagesSection.vue?vue&type=template&id=19a4ef1a&scoped=true&"
import script from "./LanguagesSection.vue?vue&type=script&lang=js&"
export * from "./LanguagesSection.vue?vue&type=script&lang=js&"
import style0 from "./LanguagesSection.vue?vue&type=style&index=0&id=19a4ef1a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a4ef1a",
  null
  
)

export default component.exports